"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DateOnly {
    /**
     * Factory method that returns an instance.
     */
    static create(date, month, year) {
        return new DateOnly(date, month, year);
    }
    /**
     * Factory method that return either null or an instance,
     * depending on whether the given Date instance is null.
     */
    static createFromDate(date) {
        if (!date) {
            return null;
        }
        else {
            return new DateOnly(date);
        }
    }
    constructor(date, month, year) {
        if (date instanceof Date) {
            this._date = date.getDate();
            this._month = date.getMonth();
            this._year = date.getFullYear();
        }
        else {
            this._date = date;
            this._month = month;
            this._year = year;
        }
    }
    getYear() {
        return this._year;
    }
    getMonth() {
        return this._month;
    }
    getDate() {
        return this._date;
    }
    asDate() {
        return new Date(this.getYear(), this.getMonth(), this.getDate());
    }
}
exports.default = DateOnly;
//# sourceMappingURL=DateOnly.js.map